import { calcInitialWidth, colorStrings } from "@bevco/Utilities/variables";
import { footerStyles as styles } from "@insite/content-library/Pages/Footer";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.page = {
    ...styles.page,
    css: css`
        position: relative;
        margin-top: 60px;

        &::before {
            content: "";
            border-top: 1px solid ${getColor(colorStrings.commonBorder)};
            position: absolute;
            top: 0;
            right: 0;
            left: 50%;
            height: 1px;
            z-index: 1;
            width: ${calcInitialWidth};
            transform: translateX(-50%);
        }

        &&& {
            padding-top: 0;
            padding-bottom: 0;
        }
    `,
};
